import React, { Component } from 'react';
import { inject } from 'mobx-react';
import InquiryTableRow from './InquiryTableRow';
import { post } from 'axios';
import { isEmpty } from '../../utils';
import Modal from 'react-bootstrap4-modal';
import InquiryProposal from './InquiryProposal';
import InquiryQuickview from './InquiryQuickview';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';


@inject('userStore')
class Inquiries extends Component {
    constructor(props){
        super(props);
        this.state = {
            original_list:[],
            inquiry_list: [],
            visible:false,
            modalTitle:'Test Title',
            component:null,
            inquiry:null,
            proposalInquiry:null,
            quickviewInquiry:null,
            activeTab:'need-review',
            quickviewVisible:false,
            searchValue:'',
            loading:false,
            bus_book_type_stage_list:[]
        }
        this.fetchInquiries = this.fetchInquiries.bind(this);
        this.modalBackgroundClicked = this.modalBackgroundClicked.bind(this);
        this.modalHandler = this.modalHandler.bind(this);
        this.proposalHandler = this.proposalHandler.bind(this);
        this.back = this.back.bind(this);
        this.setActiveTab = this.setActiveTab.bind(this);
        this.quickviewHandler = this.quickviewHandler.bind(this);
        this.sortBy = this.sortBy.bind(this);
        this.sortByLastname = this.sortByLastname.bind(this);
        this.sortByAge = this.sortByAge.bind(this);
        this.sortByEventdate = this.sortByEventdate.bind(this);
        this.valueChange = this.valueChange.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.closeHandler = this.closeHandler.bind(this);
    }

    componentDidMount() {
        this.fetchInquiries('need-review');
    }

    setActiveTab(tab){
      this.fetchInquiries(tab);
    }

    valueChange(event){
        this.setState({searchValue: event.target.value}, () => {
            // filter the array
            this.setState({
                inquiry_list:this.state.original_list
            }, () => {
                if (this.state.searchValue.length > 2){
                    var searchList = this.state.inquiry_list.filter((inquiry) =>
                        inquiry.email.toLowerCase().includes(this.state.searchValue.toLowerCase()) |
                        inquiry.full_name.toLowerCase().includes(this.state.searchValue.toLowerCase()) |
                        inquiry.location_name.toLowerCase().includes(this.state.searchValue.toLowerCase()) |
                        inquiry.phone.toLowerCase().includes(this.state.searchValue.toLowerCase())
                    );
                    this.setState({
                        inquiry_list:searchList
                    });
                }
            })
        });
    }

    clearSearch(){
        this.setState({
            searchValue:'',
            inquiry_list:this.state.original_list
        })
    }

    sortBy(sortType){
        switch (sortType) {
            case 'LASTNAME':
                this.setState({
                    inquiry_list:this.state.inquiry_list.sort(this.sortByLastname)
                })
                break;
            case 'AGE':
                this.setState({
                    inquiry_list:this.state.inquiry_list.sort(this.sortByAge)
                })
                break;
            case 'EVENTDATE':
                this.setState({
                    inquiry_list:this.state.inquiry_list.sort(this.sortByEventdate)
                })
                break;
            default:

        }
    }

    sortByLastname(a,b) {
        if (a.last_name < b.last_name)
            return -1;
        if (a.last_name > b.last_name)
            return 1;
        return 0;
    }

    sortByEventdate(a,b) {
        if (a.days_until < b.days_until)
            return -1;
        if (a.days_until > b.days_until)
            return 1;
        return 0;
    }

    sortByAge(a,b) {
        if (a.age_minutes < b.age_minutes)
            return -1;
        if (a.age_minutes > b.age_minutes)
            return 1;
        return 0;
    }

    quickviewHandler(inquiry){
        if (this.state.quickviewVisible && this.state.quickviewInquiry !== inquiry){
            this.setState({
                quickviewInquiry:inquiry
            })
        } else {
            this.setState({
                quickviewVisible:!this.state.quickviewVisible,
                quickviewInquiry:inquiry
            })
        }
    }

    modalBackgroundClicked(inquiry){
        this.setState({
            visible:!this.state.visible, component:null
        }, () => {
            console.log(inquiry);
            if (inquiry){
                this.proposalHandler(inquiry);
            }
        });
    }

    modalHandler(inquiry, component, title){
      let updatedInquiry = inquiry;
      if (title === 'Requested Services'){
        post('v2/get/inquiry', {
          hash_id: inquiry.hash_id
        }, {
          auth: {username: this.props.userStore.token}
        }).then((res) => {
          updatedInquiry = res.data.inquiry
          this.setState({
            inquiry:updatedInquiry,
            component:component,
            visible:!this.state.visible,
            modalTitle:title
          })
        }).catch((error) => {
          return error;
        });
      } else {
        this.setState({
          inquiry:updatedInquiry,
          component:component,
          visible:!this.state.visible,
          modalTitle:title
        })
      }
    }

    proposalHandler(inquiry){
        this.setState({
            proposalInquiry:inquiry
        })
    }

    closeHandler(){
        this.setState({
            quickviewVisible:false
        })
    }

    back(){
        this.setState({
            proposalInquiry:null
        })
    }

    selectInquiryByHash = (hash_id) => {
      let index = this.state.inquiry_list.findIndex(x => x.hash_id === hash_id);
      let inquiry = this.state.inquiry_list[index];
      this.quickviewHandler(inquiry);
    }


    fetchInquiries(filter){
      this.setState({
        loading:true
      })
      post('v2/get/inquiries', {
        filter:filter,
        business_hash_id: this.props.userStore.business_primary.hash_id
      }, {
        auth: {username: this.props.userStore.token}
      }).then((res) => {
        this.setState({
          inquiry_list:res.data.inquiry_list,
          original_list:res.data.inquiry_list,
          bus_book_type_stage_list:res.data.bus_book_type_stage_list,
          activeTab:filter,
          loading:false
        }, ()=>{
          if (this.props.location.state && this.props.location.state.hash_id){
            this.selectInquiryByHash(this.props.location.state.hash_id)
          }
        });
      }).catch((error) => {
        return error;
      });
    }


    stageHandler = (e) => {
      let value = e.target.value;
      post('v2/save/inquiry_stage', {
        hash_id:this.state.quickviewInquiry.hash_id,
        bus_book_type_stage_id:value
      }, {
        auth: {username: this.props.userStore.token}
      }).then((res) => {
        if (res.data.errors === 0){
          // remove this inquiry from the current view unless it hasn't changed
          let tmpInquiry = Object.assign({}, this.state.quickviewInquiry);
          tmpInquiry.bus_book_type_stage_id = value;
          this.setState({
            quickviewInquiry:tmpInquiry
          }, () => this.fetchInquiries(this.state.activeTab));
        }
      }).catch((error) => {
        return error;
      });
    }


  render() {
      const { inquiry_list, original_list } = this.state;
      return (
        <React.Fragment>
            <Modal visible={this.state.visible} onClickBackdrop={() => this.modalBackgroundClicked()} dialogClassName="modal-lg">
                <div className="modal-header">
                    <h4 className="modal-title">{this.state.modalTitle}</h4>
                    <button type="button" className="close" onClick={() => this.modalBackgroundClicked(null)} aria-label="Close">
                      <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div className="modal-body">
                    {this.state.component ? <this.state.component inquiry={this.state.inquiry} handler={this.modalBackgroundClicked}/> : null}
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => this.modalBackgroundClicked(null)}>
                      Close
                    </button>
                </div>
            </Modal>
            {this.state.proposalInquiry ?
                <InquiryProposal handler={this.back} inquiry={this.state.proposalInquiry}/>
            :
            <React.Fragment>
            <header className="header mb-0">
                <div className="header-action pt-20">
                    <ul className="nav nav-tabs">
                        <li className="nav-item">
                            <a className={this.state.activeTab === "need-review" ? "nav-link cursor-pointer active" : "nav-link cursor-pointer"} onClick={() => this.setActiveTab('need-review')}>Needing Review</a>
                        </li>
                        <li className="nav-item">
                            <a className={this.state.activeTab === "need-proposal" ? "nav-link cursor-pointer active" : "nav-link cursor-pointer"} onClick={() => this.setActiveTab('need-proposal')}>Needing Proposal</a>
                        </li>
                        <li className="nav-item">
                            <a className={this.state.activeTab === "proposal-review" ? "nav-link cursor-pointer active" : "nav-link cursor-pointer"} onClick={() => this.setActiveTab('proposal-review')}>Proposal Review</a>
                        </li>
                        <li className="nav-item">
                            <a className={this.state.activeTab === "awaiting-contract" ? "nav-link cursor-pointer active" : "nav-link cursor-pointer"} onClick={() => this.setActiveTab('awaiting-contract')}>Awaiting Contract</a>
                        </li>
                        <li className="nav-item">
                            <a className={this.state.activeTab === "orphaned" ? "nav-link cursor-pointer active" : "nav-link cursor-pointer"} onClick={() => this.setActiveTab('orphaned')}>Orphaned</a>
                        </li>
                        <li className="nav-item">
                            <a className={this.state.activeTab === "inactive" ? "nav-link cursor-pointer active" : "nav-link cursor-pointer"} onClick={() => this.setActiveTab('inactive')}>Inactive</a>
                        </li>
                    </ul>
                </div>
            </header>
            <div className="main-content pt-0">
                <header className="flexbox align-items-center media-list-header bg-transparent b-0 py-16 pl-20">
                    <div className="flexbox align-items-center">
                        <div className="dropdown">
                            <a className="btn btn-sm dropdown-toggle" data-toggle="dropdown">Sort by</a>
                            <div className="dropdown-menu">
                                <a className="dropdown-item" onClick={() => this.sortBy('EVENTDATE')}>Event Date</a>
                                <a className="dropdown-item" onClick={() => this.sortBy('AGE')}>Date Created</a>
                                <a className="dropdown-item" onClick={() => this.sortBy('LASTNAME')}>Name</a>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="lookup lookup-circle lookup-right">
                            <input type="text" value={this.state.searchValue} onChange={this.valueChange}/>
                        </div>
                        {this.state.searchValue !== '' ? <button className="ml-10 btn btn-outline btn-sm btn-danger" onClick={this.clearSearch}>Clear</button> : null}
                    </div>
                </header>
                <div className="tab-content">
                <PerfectScrollbar>
                {this.state.loading
                  ?
                  <div className="spinner-ball"></div>
                  :
                  !isEmpty(original_list) ?
                  <div className="tab-pane active media-list media-list-divided media-list-hover" data-provide="selectall">
                      <table style={{width:100+"%"}}>
                          <tbody className="media-list-body bg-white b-1">
                          {inquiry_list.map((inquiry, inquiry_index) =>
                            <InquiryTableRow inquiry={inquiry} key={inquiry_index} qHandler={this.quickviewHandler} handler={this.modalHandler}/>
                          )}
                          </tbody>
                      </table>
                  </div>
                  : <div className="p-30 fs-25 fw-500 text-center">No Results Found</div>
                }
                </PerfectScrollbar>
                </div>
            </div>
            <div className={this.state.quickviewVisible ? "quickview quickview-lg reveal" : "quickview quickview-lg"}>
            {this.state.quickviewInquiry ?
                <InquiryQuickview quickviewInquiry={this.state.quickviewInquiry} modalHandler={this.modalHandler} proposalHandler={this.proposalHandler} closeHandler={this.closeHandler} bus_book_type_stage_list={this.state.bus_book_type_stage_list} stageHandler={this.stageHandler}/>
              : <div>Loading</div>}
            </div>
            </React.Fragment>
        }
        </React.Fragment>
    );
  }
}

export default Inquiries;



// WEBPACK FOOTER //
// ./src/components/business/Inquiries.js